/**
 * 浏览器 snippet 入口（IIFE）。
 * 用法：
 *   <script src="http://localhost:5180/analyse-sdk?id=pid_xxx"></script>
 *   <script>AnalyseSDK.track('event', { ... })</script>
 *
 * 也可先入队再加载：
 *   <script>window.AnalyseSDK = window.AnalyseSDK || []; AnalyseSDK.push(['track','event',{}]);</script>
 *   <script async src=".../analyse-sdk?id=pid_xxx"></script>
 */
import { bootstrapSnippet } from './snippet/bootstrap';

const api = bootstrapSnippet();
export default api;
